/** Mirrors BE `RideStartStatusEnum` — used by `metadata.statusRideStart` (driver tap) and the live-map GPS-based `realStatusRideStartByGps` (RYDE-7685). */
export enum RideStartStatusEnum {
  Early = "Early",
  OnTime = "OnTime",
  Late = "Late",
}
